import * as Inputs from "../common/hook-form/index";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import * as adminUserActions from "./adminUserActions";
import * as authSelectors from "../auth/authSelectors";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { ActionSpinner } from "../../components/ActionSpinner";

type Props = {
  onClose: () => void;
};

const validationSchema = yup.object().shape({
  firstname: yup
    .string()
    .required("Please enter first name to add person as admin"),
  lastname: yup
    .string()
    .required("Please enter last name to add person as admin"),
  email: yup.string().required("Please enter email to add person as admin"),
});

export const AddAdminUserPopup = ({ onClose }: Props) => {
  const organization = useSelector(authSelectors.selectedOrganizationKeyName);
  const dispatch = useDispatch();
  const methods = useForm({
    defaultValues: {
      firstname: "",
      lastname: "",
      email: "",
    },
    resolver: yupResolver(validationSchema),
  });
  const onSubmit = (data: any) => {
    dispatch(adminUserActions.upsertAdminUserAction(organization, data));
    // Has to navigate into the admin user edit page afterwards to change permissions
    onClose();
  };

  return (
    <Modal isOpen={true}>
      <form>
        <ModalHeader>Add admin user</ModalHeader>
        <ModalBody>
          <Inputs.InputFormField
            errors={methods.formState.errors}
            register={methods.register}
            label="Email"
            name="email"
          />
          <Inputs.InputFormField
            errors={methods.formState.errors}
            register={methods.register}
            label="Firstname"
            name="firstname"
          />
          <Inputs.InputFormField
            errors={methods.formState.errors}
            register={methods.register}
            label="Lastname"
            name="lastname"
          />
        </ModalBody>
        <ModalFooter>
          <button type="button" className="btn btn-default" onClick={onClose}>
            Close
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={methods.handleSubmit(onSubmit)}
            disabled={methods.formState.isSubmitting}
          >
            {methods.formState.isSubmitting ? (
              <ActionSpinner />
            ) : (
              "Add and edit permissions"
            )}
          </button>
        </ModalFooter>
      </form>
    </Modal>
  );
};
